import { esc } from '../format';

export type RecoveryContext = 'signup' | 'recovered' | 'new';

/** Full-screen "save this" step for a recovery code. Shown once; Hush cannot show it again. */
export function vRecoveryCode(code: string, context: RecoveryContext): string {
  const lede = {
    signup: 'Your budget is ready. Before you start, save this recovery code.',
    recovered: 'You are back in. Your old code is used up, so here is a new one.',
    new: 'Here is your new recovery code. The old one no longer works.',
  }[context];
  return `<section class="welcome">
  <h1>Save this code</h1>
  <p class="lede">${lede} It signs you in on a new device, or here if this browser forgets you. It works once, and Hush cannot show it again.</p>
  <code class="code" id="rcode">${esc(code)}</code>
  <div class="btns"><button class="btn" data-a="copy" data-from="rcode">Copy code</button></div>
  <p class="hint">Keep it in a password manager or somewhere you can find it later, not only on this device.</p>
  <label class="check"><input type="checkbox" id="r-saved" data-a="recovery-saved"><span>I saved my recovery code</span></label>
  <button class="btn primary" data-a="recovery-done" disabled>Continue</button>
</section>`;
}
